export default "__VITE_ASSET__DIrpukSM__"